var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6302 16.5102L14.3102 5.19018C13.8002 4.40018 12.9402 3.93018 12.0002 3.93018C11.0602 3.93018 10.2002 4.40018 9.69019 5.19018L2.37019 16.5102C1.81019 17.3702 1.77019 18.4202 2.26019 19.3202C2.75019 20.2202 3.65019 20.7602 4.68019 20.7602L19.3302 20.7602C20.3502 20.7602 21.2602 20.2202 21.7502 19.3202C22.2402 18.4202 22.2002 17.3702 21.6402 16.5102H21.6302Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow_up_icon.aa6736a200bb0bc5d6e6216dc10ea0d8.svg";
export { ForwardRef as ReactComponent };